import { AttachFile, Language, Mic, Send } from '@mui/icons-material'
import { IconButton, IconButtonProps } from '@mui/material'
import React from 'react'

type PromptIcon = 'language' | 'attach' | 'mic' | 'send'

const PROMPT_ICONS: Record<PromptIcon, React.ReactNode> = {
  language: <Language />,
  attach: <AttachFile />,
  mic: <Mic />,
  send: <Send />,
}

interface PromptAttachmentButtonProps {
  type?: 'button' | 'submit'
  variant?: 'primary' | 'secondary' | 'pulse'
  icon: PromptIcon
  hidden?: boolean
  disabled?: boolean
  active?: boolean
  onClick?: IconButtonProps['onClick']
}

export default function PromptAttachmentButton({
  variant = 'secondary',
  icon,
  hidden,
  active,
  ...buttonProps
}: PromptAttachmentButtonProps) {
  return (
    <IconButton
      type="button"
      sx={{
        display: hidden ? 'none' : undefined,
        border: 'none',
        height: '32px',
        width: '32px !important',
        padding: '4px',
        borderRadius: '4px',
        color: t => {
          if (active) return t.colors.base[30]

          switch (variant) {
            case 'primary':
              return t.colors.base[20]
            case 'secondary':
              return t.colors.base[45]
            case 'pulse':
              return t.palette.global.yellow
          }
        },
        ...(variant === 'pulse' && {
          animation: 'pulse 1s infinite',
        }),
        '@keyframes pulse': {
          '0%': {
            color: t => t.palette.global.yellow,
            transform: 'scale(1)',
          },
          '50%': {
            color: t => t.colors.base[45],
            transform: 'scale(1.1)',
          },
          '100%': {
            color: t => t.palette.global.yellow,
            transform: 'scale(1)',
          },
        },
      }}
      {...buttonProps}
    >
      {PROMPT_ICONS[icon]}
    </IconButton>
  )
}
